import {
  PeriodStats,
  PeriodStatsParams,
  StatsClients,
  StatsLanguage,
} from "core/types/stats.types";
import { ApiFactoryClients } from "../api.types";

// Contratto con il backend (resoconto per periodo):
//
//   GET /stats/period?period=30d|3m|6m|12m&user_id=<id>|all  oppure &customer=<intestatario>
//       -> PeriodStats (delegabile: in act-as parte con X-Act-As e il backend scopa sul
//       cliente). user_id e customer sono alternativi: tutti e due = 400.
//   GET /stats/period/report?period=..&user_id=..|customer=..&lang=it|en -> PDF (attachment)
//       (solo operatori, NON delegabile: in act-as si passa user_id del cliente)
//   GET /stats/clients -> StatsClients (solo operatori, NON delegabile)

// Estrae il nome file da Content-Disposition (filename*=UTF-8''... o filename="...").
const filenameFromDisposition = (header?: string): string | undefined => {
  if (!header) return undefined;
  const star = /filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i.exec(header);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim().replace(/^"|"$/g, ""));
    } catch {
      // nome codificato male: si prova con filename=
    }
  }
  const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(header);
  return plain ? plain[1].trim() : undefined;
};

const toQuery = (params: Record<string, string | undefined>) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== "") query.append(key, value);
  });
  return query.toString();
};

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ codeHttpClient }: ApiFactoryClients<"codeHttpClient">) => ({
  getPeriod: ({ period, userId, customer }: PeriodStatsParams): Promise<PeriodStats> =>
    codeHttpClient
      .get(`/stats/period?${toQuery({ period, user_id: userId, customer })}`)
      .then(({ data }) => data),
  getClients: (): Promise<StatsClients> =>
    codeHttpClient.get(`/stats/clients`).then(({ data }) => data),
  downloadPeriodReport: (
    { period, userId, customer }: PeriodStatsParams,
    lang: StatsLanguage
  ): Promise<{ data: ArrayBuffer; filename?: string }> =>
    codeHttpClient
      .get(`/stats/period/report?${toQuery({ period, user_id: userId, customer, lang })}`, {
        responseType: "arraybuffer",
      })
      .then(({ data, headers }) => ({
        data,
        filename: filenameFromDisposition(headers?.["content-disposition"]),
      })),
});
